// @flow
import React, { Component, Fragment } from 'react';
import type { State } from 'store';
import { connect } from 'react-redux';
import EstimateSection from 'components/estimate/EstimateSection/EstimateSection';
import EstimateTableContainer from './EstimateTableContainer';
import EstimateViewContainer from './EstimateViewContainer';

type Props = {};

class EstimateSections extends Component<Props> {
  render() {
    return (
      <Fragment>
        <EstimateSection name="견적 요청 업로드">
          <EstimateTableContainer id={this.props.id} />
          <EstimateViewContainer id={this.props.id} />
        </EstimateSection>
      </Fragment>
    );
  }
}

export default connect(
  ({ estimate }: State) => ({
    selectEstimateBox: estimate.selectEstimateBox,
  }),
  () => ({}),
)(EstimateSections);



// WEBPACK FOOTER //
// ./src/containers/estimate/EstimateSections.js